import Vue from 'vue';

export const MODERN_THEME_KEY = 'eurekers-modern-theme';

export class ModernThemeController {
  constructor({ matchMedia = window.matchMedia.bind(window), body = document.body } = {}) {
    this.matchMedia = matchMedia;
    this.body = body;
    this.media = null;
    this.root = null;
    this.mode = 'system';
    this.state = Vue.observable({ effectiveTheme: 'light' });
    this.previousBodyBackground = '';
    this.listener = () => this.apply();
  }

  mount(root, mode = 'system') {
    this.root = root;
    this.previousBodyBackground = this.body.style.backgroundColor;
    this.setMode(mode);
  }

  setMode(mode) {
    this.detachMedia();
    this.mode = ['light', 'dark', 'system'].includes(mode) ? mode : 'system';
    if (this.mode === 'system') {
      this.media = this.matchMedia('(prefers-color-scheme: dark)');
      if (this.media.addEventListener) this.media.addEventListener('change', this.listener);
      else if (this.media.addListener) this.media.addListener(this.listener);
    }
    this.apply();
  }

  effectiveTheme() {
    if (this.mode !== 'system') return this.mode;
    return this.media && this.media.matches ? 'dark' : 'light';
  }

  apply() {
    const effective = this.effectiveTheme();
    this.state.effectiveTheme = effective;
    if (!this.root) return;
    this.root.classList.toggle('modern-theme-dark', effective === 'dark');
    this.root.classList.toggle('modern-theme-light', effective === 'light');
    // ChartingNext already scopes its dark compatibility rules to this class.
    this.root.classList.toggle('dark-theme', effective === 'dark');
    this.root.classList.toggle('light-theme', effective === 'light');
    this.body.style.backgroundColor = effective === 'dark' ? '#10131a' : '#f6f8fb';
  }

  detachMedia() {
    if (!this.media) return;
    if (this.media.removeEventListener) this.media.removeEventListener('change', this.listener);
    else if (this.media.removeListener) this.media.removeListener(this.listener);
    this.media = null;
  }

  unmount() {
    this.detachMedia();
    if (this.body) this.body.style.backgroundColor = this.previousBodyBackground;
    this.root = null;
  }
}
